import React from 'react';

const ColorOrderModal = () => {
	return (
		<>
			<div className="popup-wrapper  width-720-modal">
				<div className="common-popup color-and-size-order-modal">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Size And Color Wise Order</h3>
						</div>
						<div className="close-btn">
							<img src="/icons/close.svg" alt="close" />
						</div>
					</div>
					<div className="common-popup-body scroll-y-label">
						<div className="delivery-and-qunt-header">
							<div className="d-flex justify-content-between align-self-center">
								<p className="semibold-14">Final delivery date :</p>
								<div className="from-group">
									<input type="date" />
								</div>
							</div>
							<div className="d-flex justify-content-between align-self-center mt-3">
								<p className="semibold-14">Total shipped quantity :</p>
								<div className="from-group">
									<input type="text" />
								</div>
							</div>
						</div>
						<div className="mt-4">
							<div className="create-order-container">
								<div className="design-quantity-table">
									<div className="d-flex justify-content-between align-self-center my-3">
										<p className="semibold-14">Buyer price:</p>
										<div className="d-flex justify-content-between align-self-center">
											<p className="gray_dark_02 regular-14">
												Sizewise <img src="icons/down-arrow.png" />
											</p>
											<p className="gray_dark_02 regular-14 ml-2">
												FOB <img src="icons/down-arrow.png" />
											</p>
										</div>
									</div>
									<div className="design-table d-block">
										<div className="category-wise-table sizewise-wise-table">
											<table className="table">
												<thead>
													<tr>
														<th>
															<p className="semibold-14 col-heading">XS</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">S</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">M</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">L</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">XL</p>
														</th>
														<th>
															<p className="semibold-14 col-heading cursor-pointer">
																<img src="/icons/plus-20.svg" alt="plus" />
															</p>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
													</tr>

													<tr>
														<td />
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00 " />
														</td>
														<td />
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>

								<div className="design-quantity-table">
									<div className="d-flex justify-content-between align-self-center my-3">
										<p className="semibold-14">Buyer price:</p>
										<div className="d-flex justify-content-between align-self-center">
											<p className="gray_dark_02 regular-14">
												Sizewise <img src="icons/down-arrow.png" />
											</p>
											<p className="gray_dark_02 regular-14 ml-2">
												FOB <img src="icons/down-arrow.png" />
											</p>
										</div>
									</div>
									<div className="design-table d-block">
										<div className="category-wise-table sizewise-wise-table">
											<table className="table">
												<thead>
													<tr>
														<th>
															<p className="semibold-14 col-heading">XS</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">S</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">M</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">L</p>
														</th>
														<th>
															<p className="semibold-14 col-heading">XL</p>
														</th>
														<th>
															<p className="semibold-14 col-heading cursor-pointer">
																<img src="/icons/plus-20.svg" alt="plus" />
															</p>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
													</tr>

													<tr>
														<td />
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00 " />
														</td>
														<td />
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
								<div className="design-quantity-table">
									<div className="d-flex justify-content-between align-self-center my-3">
										<p className="semibold-14">Buyer price:</p>
										<div className="d-flex justify-content-between align-self-center">
											<p className="gray_dark_02 regular-14">
												Colorwise <img src="icons/down-arrow.png" />
											</p>
											<p className="gray_dark_02 regular-14 ml-3">
												FOB <img src="icons/down-arrow.png" />
											</p>
										</div>
									</div>
									<div className="design-table d-block">
										<div className="category-wise-table sizewise-wise-table">
											<table className="table">
												<thead>
													<tr>
														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>
														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>

														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>
														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>
														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>
														<th>
															<span>
																<div className="colors-row">
																	<div className="multicolors">
																		<span
																			className="color-icon cursor-pointer"
																			style={{
																				background: 'rgb(26, 26, 25)'
																			}}
																			title="Black"
																		></span>
																	</div>
																</div>
															</span>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
														<td>
															<input type="number" placeholder="00" />
														</td>
													</tr>

													<tr>
														<td />
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00" />
														</td>
														<td>
															<input type="number" placeholder="$00.00 " />
														</td>
														<td />
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2">Submit</button>
							<button className="button size32 ml-2">Submit</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default ColorOrderModal;
